<template>
  <el-checkbox
    v-model="checked"
    :disabled="disabled"
    @change="changeCheck">
    <slot></slot>
  </el-checkbox>
</template>
<script>
export default {
  name: 'VCheckbox',
  props: {
    value: {
      type: [Boolean, Number],
      default: false
    },
    disabled:{
      type:Boolean,
      default: false
    },
    isBoolean: {
      type: Boolean,
      default: false
    },
    selectNumber:{
      type: [Boolean, Number],
      default: 1
    }
  },
  data() {
    return {
      checked: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.checked = val==this.selectNumber
        this.$emit('input', Number(val))
        
      }
    },
  },
  methods: {
    changeCheck(val) {
      const result = this.isBoolean? val: Number(val)
      this.$emit('input', result)
      this.$emit('change', result)
    }
  }
}
</script>
<style lang="scss">
::v-deep .el-checkbox{
  .is-checked{
    .el-checkbox__inner{
      background: #076081!important;
      border-color:#076081;
    }
  }
}
</style>